import type { ArticleBlock } from "@/mocks/articles";

interface ArticleBodyProps {
  blocks: ArticleBlock[];
}

export default function ArticleBody({ blocks }: ArticleBodyProps) {
  let headingIndex = 0;

  return (
    <div className="flex flex-col gap-5">
      {blocks.map((block, index) => {
        if (block.type === "h2") {
          headingIndex += 1;
          return (
            <h2
              key={index}
              id={`sec-${headingIndex}`}
              className="scroll-mt-28 pt-4 font-heading text-xl md:text-2xl leading-snug text-foreground-950"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === "h3") {
          return (
            <h3 key={index} className="pt-2 font-heading text-lg text-foreground-900">
              {block.text}
            </h3>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote key={index} className="my-2 pl-5 border-l-2 border-accent-500">
              <p className="font-heading text-lg md:text-xl leading-relaxed text-foreground-800">{block.text}</p>
            </blockquote>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={index} className="flex flex-col gap-3">
              {block.items?.map((item, itemIndex) => (
                <li key={itemIndex} className="flex gap-3 text-[15px] leading-[1.9] text-foreground-700">
                  <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-500 mt-3 shrink-0"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={index} className="text-[15px] md:text-base leading-[1.95] text-foreground-700">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}